import React from "react";

import { NAVIGATION_ROUTES } from "#routes/routes.constant";
import styles from "./ErrorBoundary.module.scss";

interface Props {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  private handleReload = () => {
    window.location.reload();
  };

  private handleGoHome = () => {
    window.location.href = NAVIGATION_ROUTES.DASHBOARD;
  };

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div className={styles.overlay}>
            <div className={styles.card}>
              <h1 className={styles.heading}>Oops!</h1>

              {/* This now wraps long text */}
              <p className={styles.message}>
                {this.state.error?.message || "Something went wrong."}
              </p>

              <div className={styles.actions}>
                <button onClick={this.handleReload} className={styles.btn}>
                  Try Again
                </button>
                <button onClick={this.handleGoHome} className={styles.btn}>
                  Go to Dashboard
                </button>
              </div>
            </div>
          </div>
        )
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
